import { LOCATION_CHANGE } from 'react-router-redux';
import { clearPosts } from '../actions/clear-posts';
import { isInitialLocation } from '../selectors/location-history-selectors';
import { isInCategory, isInFeed } from '../services/detect-route';

export default function createPostClearMiddleware() {
  let lastPathname = null;
  const hasPage = pathname => pathname && /\/page\/\d+\/?$/.test(pathname);
  const navigateFromPageToTop = pathname => hasPage(lastPathname) && !hasPage(pathname);
  const withoutPage = pathname => pathname && pathname.replace(/(\/page\/\d+)?\/?$/, '/');
  const changed = pathname => navigateFromPageToTop(pathname) || withoutPage(lastPathname) !== withoutPage(pathname);
  const shouldClear = location => (isInCategory(location) || isInFeed(location)) && changed(location.pathname);

  return store => next => action => {
    const { type, payload } = action;

    if (type === LOCATION_CHANGE) {
      if (shouldClear(payload) && !isInitialLocation(store.getState())) {
        store.dispatch(clearPosts());
      }
      lastPathname = payload.pathname;
    }

    return next(action);
  };
}
